import React, { Component } from 'react'
import styles from './WorkflowForm.module.css'
import options from './options.json';
import Icon from '../../components/Icon/Icon';


class WorkflowResult extends Component {
    constructor(props) {
        super(props);
        
    }

    getTin() {

        var arr = this.props.data.WORKFLOW_JSON.split('|');
        var json_tin = '';
        var data_tin = this.props.data.TIN;

        for (let i = 0; i < arr.length; i++) {
            let name = arr[i].split('=')[0];
            if (name==='TIN') {
                json_tin = arr[i].split('=')[1];
            }
        }

        let first2 = json_tin.replace('-', '').substring(0, 2);
        let last7 = json_tin.replace('-', '').substring(2, 9);

        let formattedStr = first2 + '-' + last7;
        return formattedStr;
    }
    render() {

        var color = 'black';


        switch (this.props.data.STATUS) {
            case 'CANCELED':
                color = 'red';
                break;
            case 'APPROVED':
                color = 'green';
                break;
            case 'REJECTED':
                color = 'red';
                break;
            default:
                color = 'black';
        }

        let rowStyles = []
        if (this.props.diableCloseout == 'highlight') {
            rowStyles.push(styles.highlightRow)
        } else if (this.props.odd) {
            rowStyles.push(styles.odd)
        } else {
            rowStyles.push(styles.even)
        }

        rowStyles.push(styles.contentrow)
       
        return (


            <div className={rowStyles.join(" ")}>

                <div className={[styles.contentitemstatus, styles[color]].join(" ")}>{this.props.data.STATUS}</div>
                <div className={[styles.contentitemshort].join(" ")}>{this.props.data.SUBMIT_NAME}</div>
                <div className={styles.contentitemxshort}>{new Date(this.props.data.SUBMIT_DATE).toLocaleDateString('en-US')}</div>
                <div className={styles.contentitemlong}>{this.props.data.ORG_NAME}</div>
                <div className={styles.contentitemlong}>{this.props.data.PROGRAM_TITLE}</div>
                <div className={styles.contentitemshort}>${this.props.data.AMOUNT}</div>
                <div className={styles.contentitemshort}>{this.props.data.PAYMENT_METHOD}</div>
                <div className={styles.contentitemxshort}>{new Date(this.props.data.START_DT).toLocaleDateString('en-US')}</div>
                <div className={styles.contentitemxshort}>{new Date(this.props.data.END_DT).toLocaleDateString('en-US')}</div>
                <div className={styles.contentitemsap}>{this.props.data.IS_SAP ? <Icon name="check" /> : null}</div>
                <div className={styles.contentitemtin}>{this.getTin()}</div>
                <div className={styles.contentaction}>
                    <div className={styles[this.props.changeViewColor]} onClick={() => {
                        this.props.showStatus(this.props.data.WORKFLOW_INSTANCE_ID)
                    }}>VIEW</div>

                    <div className={styles[this.props.disableEdit]} onClick={() => {

                        if (this.props.disableEdit == 'enabled') {

                            this.props.edit(this.props.data.WORKFLOW_INSTANCE_ID, this.props.data.ORG_ID);
                        }

                    }}>EDIT</div>


                    <div className={this.props.diableCloseout == 'enabled' ? styles['enabled'] : styles['disabled']} onClick={() => {
                        if (this.props.diableCloseout == 'enabled') {
                            this.props.showCloseout(this.props.data.WORKFLOW_INSTANCE_ID);
                        }

                    }}>CLOSE</div>
                    <div className={styles[this.props.diableExport]} onClick={() => {
                        this.props.exportFn(this.props.data.WORKFLOW_INSTANCE_ID)
                    }}>EXPORT</div>
                </div>

            </div>
        )
    }

}
export default WorkflowResult;







